import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { shadows as shadowsChakraUi } from "src/theme/shadows";
import { MuiAccordion, MuiAccordionDetails, MuiAccordionSummary } from "src/theme-mui/components/accordion/accordion-styles";
import { MuiChip } from "src/theme-mui/components/chip/chip-styles";
import { MuiDivider } from "src/theme-mui/components/divider/mui-divider";
import { MuiFormControlLabel } from "src/theme-mui/components/form/form-control-label-styles";
import { MuiCircularProgress } from "src/theme-mui/components/progress/progress-styles";
import { MuiRadio } from "src/theme-mui/components/radio/radio-styles";
import { MuiSlider } from "src/theme-mui/components/slider/mui-slider";
import { MuiSwitch } from "src/theme-mui/components/switch/switch";
import { MuiTypography } from "src/theme-mui/components/typography/mui-typography";
import Typography from "../theme/typography";
import { MuiButton } from "./components/button/button-styles";
import { MuiCheckbox } from "./components/checkbox/checkbox-styles";
import { MuiFormHelperText } from "./components/form/form-helper-text-styles";
import { MuiFormLabel } from "./components/form/form-label-styles";
import { MuiIconButton } from "./components/icon-button/icon-button-styles";
import { MuiOutlinedInput } from "./components/input/input-styles";
import { MuiLink } from "./components/link/link-styles";
import { MuiSvgIcon } from "./components/svg-icon/svg-icon-styles";
import { palette } from "./tokens/palette";
import { shadows } from "./tokens/shadows";

const theme = createTheme({
    cssVariables: true,
    spacing: (factor: number) => `${factor * 8}px`,
    shape: {
        borderRadius: 8,
    },
    customShadows: shadowsChakraUi,
    shadows,
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 100000,
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiSlider,
        MuiButton,
        MuiIconButton,
        MuiOutlinedInput,
        MuiFormLabel,
        MuiFormHelperText,
        MuiLink,
        MuiSvgIcon,
        MuiTypography,
        MuiDivider,
        MuiCheckbox,
        MuiRadio,
        MuiFormControlLabel,
        MuiAccordion,
        MuiAccordionSummary,
        MuiAccordionDetails,
        MuiSwitch,
        MuiCircularProgress,
        MuiChip,
    },
    palette,
    typography: {
        fontFamily: Typography.fonts.body,
        fontWeightRegular: Typography.fontWeights.normal,
        fontWeightMedium: Typography.fontWeights.medium,
        fontWeightSemibold: Typography.fontWeights.semibold,
        fontWeightBold: Typography.fontWeights.bold,
        fontWeightHeavy: Typography.fontWeights.heavy,

        "2xs": "0.625rem", // 10px
        xs: "0.75rem", // 12px
        sm: "0.875rem", // 14px
        md: "1rem", // 16px
        lg: "1.125rem", // 18px
        xl: "1.25rem", // 20px
        "2xl": "1.5rem", // 24px
        "3xl": "2rem", // 32px
        "4xl": "2.5rem", // 40px
        "5xl": "3.75rem", // 60px
        "6xl": "5rem", // 80px
    },
});

//TODO: https://mui.com/material-ui/customization/theming/#responsivefontsizes-theme-options-theme
const themeWithResponsiveFontSizes = responsiveFontSizes(theme);

export default themeWithResponsiveFontSizes;
